import React, { useState, useEffect } from "react";
import {
  Redirect,
  useHistory,
} from "react-router-dom";
import {
  shallowEqual,
  useDispatch,
  useSelector
} from "react-redux";

import {
  isGetUserLoading
} from '../../../../../../store/collaborator/selectors';

import {
  isUserTokenValid
} from '../../../../../../store/authentication/selectors';

import {
  getSamlIsLoading,
  getSamlSuccess,
  getSamlIsError
} from '../../../../../../store/sso/selectors';

import {
  getCompanyData
} from '../../../../../../store/company/selectors';

import {
  samlRegisteration
} from '../../../../../../store/sso/actions';

import { logout } from '../../../../../../store/authentication/actions';

import GenericLoader from '../../../../../../components/molecules/GenericLoader';
import GenericCheckbox from '../../../../../../components/molecules/GenericCheckbox';
import CGUModal from "../../../../../../components/organisms/CGUModal";
import LogoWithCircle from "../../../../../../components/atoms/icons/logoWithCircle";

import { toaster } from '../../../../../../helpers/toaster';

import {
  MainContainer,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  LogoWithCircleWrapper,
  StyledConfirmationContainer,
  StyledTitle,
  StyledInfoContainer,
  StyledMessage,
  StyledInfo,
  StyledInfoTitle,
  StyledInfoText,
  StyledLink,
  StyledButton,
  StyledErrorContainer,
  StyledErrorText
} from "./style";

const QUERY_ARRAY = [
  'email',
  'firstname',
  'lastname',
  'Redirect',
  'issuer',
  'nameidentifier',
  'companySite'
];

const ERROR_TEXT = {
  'Building not found': `Votre site n’est pas reconnu. Merci de contacter votre administrateur`,
  'SAML is not activated for this environnement': `Pas activé`,
};

const HqoRegister = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [openGCU, setOpenGCU] = useState(false);
  const [acceptAgreement, setAcceptAgreement] = useState(false);

  const query = new URLSearchParams(window.location.search);

  const queryObject = QUERY_ARRAY.reduce((acc, value) => {
    acc[value] = query.get(value);
    return (acc);
  }, {});

  const {
    isUserLoading,
    isTokenValid,
    samlIsLoading,
    samlSuccess,
    samlError,
    companyData
  } = useSelector(
    state => ({
      isUserLoading: isGetUserLoading(state),
      isTokenValid: isUserTokenValid(state),
      samlIsLoading: getSamlIsLoading(state),
      samlSuccess: getSamlSuccess(state),
      samlError: getSamlIsError(state),
      companyData: getCompanyData(state)
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(logout());
  }, []);

  const handleCheckBox = (event) => {
    setAcceptAgreement(event.target.checked);
  }

  const handleConfirm = () => {
    if (!acceptAgreement) {
      toaster(`Veuillez accepter les conditions générales d'utilisation`, 'error');
      return;
    }
    dispatch(samlRegisteration(queryObject));
  };

  const generateErrorText = () => {
    return (ERROR_TEXT[samlError.message] || ERROR_TEXT[samlError] || samlError.message);
  }

  const sendEmail = () => {
    const subject = encodeURIComponent(`HqO - ${queryObject.firstname} ${queryObject.lastname} rencontre un problème d’inscription`);
    const targetEmail = `onvousaimeonvousaide@cyconia.io`;

    window.open(`mailto:${targetEmail}?subject=${subject}`, '_blank');
  }

  if (!companyData.hqoSsoSaml) {
    return (
      <Redirect
        to={{
          pathname: "/sso/hqo-gecina/restricted",
          state: {
            from: history.location,
            error: {
              message: 'Pas activé'
            }
          }
        }}
      />
    )
  }
  if (isTokenValid && samlSuccess) {
    return (
      <Redirect
        to={{
          pathname: queryObject.redirect || '/landing',
          state: { from: history.location }
        }}
      />
    )
  }
  else {
    return (
      <MainContainer>
        <Header>
          <LogoWithCircleWrapper>
            <LogoWithCircle />
          </LogoWithCircleWrapper>
          <HeaderTitle>{'cyconia'}</HeaderTitle>
          <HeaderSubtitle>{'Votre assistant intelligent au bureau'}</HeaderSubtitle>
        </Header>
        <StyledConfirmationContainer>
          {samlIsLoading || isUserLoading ?
            <GenericLoader />
            :
            samlError ?
              <StyledErrorContainer>
                <StyledErrorText>
                  {generateErrorText()}
                </StyledErrorText>
                <StyledLink onClick={sendEmail}>
                  {`Je rencontre un problème`}
                </StyledLink>
              </StyledErrorContainer>
              :
              <>
                <StyledTitle>{'Créer votre compte'}</StyledTitle>
                <StyledMessage>
                  {`Pour bénéficier des services de Cyconia et permettre la prise en charge de vos demandes, un compte vous sera créé sur la base des informations fournies par HqO :`}
                </StyledMessage>
                <StyledInfoContainer>
                  <StyledInfo>
                    <StyledInfoTitle>{'Votre email'}</StyledInfoTitle>
                    <StyledInfoText>{queryObject.email}</StyledInfoText>
                  </StyledInfo>
                  <StyledInfo>
                    <StyledInfoTitle>{'Votre nom'}</StyledInfoTitle>
                    <StyledInfoText>{queryObject.firstname}</StyledInfoText>
                  </StyledInfo>
                  <StyledInfo>
                    <StyledInfoTitle>{'Votre prénom'}</StyledInfoTitle>
                    <StyledInfoText>{queryObject.lastname}</StyledInfoText>
                  </StyledInfo>
                  <StyledInfo>
                    <StyledInfoTitle>{'Votre site d’entreprise'}</StyledInfoTitle>
                    <StyledInfoText>{queryObject.companySite}</StyledInfoText>
                  </StyledInfo>
                </StyledInfoContainer>

                <StyledLink onClick={() => setOpenGCU(true)}>
                  {`Lire les conditions générales d'utilisation`}
                </StyledLink>

                <GenericCheckbox
                  title={`J'ai lu et j'accepte les conditions générales d'utilisation`}
                  onChange={(event) => handleCheckBox(event)}
                  checked={acceptAgreement}
                />

                {openGCU &&
                  <CGUModal
                    onClose={() => setOpenGCU(false)}
                  />
                }

                <StyledButton
                  title={`Je confirme mon inscription`}
                  onClick={handleConfirm}
                />
              </>
          }
        </StyledConfirmationContainer>
      </MainContainer>
    );
  }
};

export default HqoRegister;